export default {
    // 短信模板信息查询接口
    getSmsTemplate(params, response) {
        window.vue.$apiAxios.postRequestBody('/template/queryTemplate', params, response);
    },
    // 校验模板标识是否重复
    checkRepeat(params, response) {
        window.vue.$apiAxios.get('/template/checkRepeat', params, response);
    },
    // 短信模板删除接口
    deleteSmsTemplate(params, response) {
        window.vue.$apiAxios.postRequestBody('/template/delete', params, response);
    },
    // 短信模板添加接口
    saveSmsTemplate(params, response) {
        console.log(params)
        if (params.sId == '') {
            window.vue.$apiAxios.postRequestBody('/template/save', JSON.stringify(params), response);
        } else {
            window.vue.$apiAxios.postRequestBody('/template/update', JSON.stringify(params), response);
        }
    },
    getSelectData(params, response) {
        window.vue.$apiAxios.postRequestBody('/template/getSelectData', params, response);
    }
};
